
  import '/Users/jilin/projects/antd/rc-dialog/docs/demo/multiple-Portal.md?watch=parent';
  export const texts = [];
  